import React from 'react';
import { SEOHead } from '../components/SEOHead';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-white py-32 px-4 sm:px-6 lg:px-8">
      <SEOHead 
        title="Ochrana osobních údajů | Školobot"
        description="Informace o zpracování a ochraně osobních údajů služby Školobot. GDPR compliant."
        path="/ochrana-udaju"
      />
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">ZÁSADY OCHRANY OSOBNÍCH ÚDAJŮ</h1>
        
        <div className="space-y-6 text-sm leading-relaxed">
          {/* ZOOÚ */}
          <div>
            <h2 className="text-xl font-bold mb-3">1. Úvod a účel dokumentu</h2>
            <p className="mb-2"><strong>1.1.</strong> Tyto Zásady ochrany osobních údajů (dále jen „ZOOÚ") poskytují informace o zpracování osobních údajů v souvislosti s užíváním služby Školobot (dále jen „Služba") v souladu s nařízením Evropského parlamentu a Rady (EU) 2016/679 (GDPR).</p>
            <p className="mb-2"><strong>1.2.</strong> Správcem osobních údajů ve smyslu GDPR je <strong>THEBIGDOT s.r.o.</strong>, IČO: 19062044, se sídlem Zámostní 1155/27, Slezská Ostrava, 710 00 Ostrava (dále jen „Poskytovatel").</p>
            <p className="mb-2"><strong>1.3.</strong> Veškeré dotazy lze Poskytovateli adresovat prostřednictvím kontaktního formuláře v sekci Kontakt.</p>
            <p><strong>1.4.</strong> Tyto ZOOÚ slouží k naplnění informační povinnosti dle čl. 13 a 14 GDPR a nezakládají samostatný smluvní vztah.</p>
          </div>

          <div>
            <h2 className="text-xl font-bold mb-3">2. Postavení subjektů při zpracování osobních údajů</h2>
            <p className="mb-2"><strong>2.1. Obecně:</strong> Postavení jednotlivých subjektů se liší v závislosti na povaze osobních údajů a účelu jejich zpracování.</p>
            <p className="mb-2"><strong>2.2. Poskytovatel jako správce:</strong> Poskytovatel vystupuje jako správce pro uzavření smlouvy, provoz Služby, vedení účetnictví a plnění právních povinností.</p>
            <p className="mb-2"><strong>2.3. Poskytovatel jako zpracovatel:</strong> Ve vztahu k osobním údajům obsaženým ve Vstupních datech vystupuje Poskytovatel jako zpracovatel. Správcem je Zákazník. Zpracování se řídí Dodatkem o zpracování osobních údajů (DPA).</p>
            <p className="mb-2"><strong>2.4. Subjekty údajů:</strong> Kontaktní osoby Zákazníka, fyzické osoby uvedené v dokumentech nahraných Zákazníkem.</p>
          </div>

          <div>
            <h2 className="text-xl font-bold mb-3">3. Kategorie a rozsah zpracovávaných údajů</h2>
            <p className="mb-2"><strong>3.1.</strong> Zpracovávány mohou být osobní údaje obsažené ve Vstupních datech, technické údaje (IP adresa, logy), identifikační a kontaktní údaje Uživatelů.</p>
            <p><strong>3.2.</strong> Poskytovatel i Zákazník zpracovávají údaje pouze v nezbytném rozsahu v souladu se zásadou minimalizace dle GDPR.</p>
          </div>

          <div>
            <h2 className="text-xl font-bold mb-3">4. Účely a právní základy zpracování</h2>
            <p className="mb-3"><strong>4.1.</strong> Osobní údaje jsou zpracovávány zejména za účelem:</p>
            <ul className="list-disc ml-6 mb-3 space-y-1">
              <li>provozu a technického zajištění Služby,</li>
              <li>správy Uživatelských účtů,</li>
              <li>komunikace se Zákazníkem,</li>
              <li>zajištění bezpečnosti Služby,</li>
              <li>plnění zákonných povinností.</li>
            </ul>
            <p><strong>4.2.</strong> Právní základy: plnění smlouvy (čl. 6 odst. 1 písm. b) GDPR), plnění právních povinností (čl. 6 odst. 1 písm. c) GDPR), oprávněný zájem (čl. 6 odst. 1 písm. f) GDPR).</p>
          </div>

          <div>
            <h2 className="text-xl font-bold mb-3">6. Příjemci osobních údajů</h2>
            <p className="mb-2"><strong>6.1.</strong> V rozsahu zpracovatele jsou příjemci subdodavatelé poskytující technické a podpůrné služby.</p>
            <p className="mb-2"><strong>6.2.</strong> V rozsahu správce mohou být příjemci poskytovatelé účetních a platebních služeb.</p>
            <p><strong>6.5.</strong> Údaje jsou ukládány primárně v EU/EHP. Předání mimo EU/EHP proběhne v souladu s GDPR.</p>
          </div>

          <div>
            <h2 className="text-xl font-bold mb-3">7. Doba uchovávání</h2>
            <p className="mb-2"><strong>7.1.</strong> Údaje zpracovávané jako správcem jsou uchovávány po dobu trvání smlouvy a následně po dobu vyžadovanou právními předpisy.</p>
            <p><strong>7.3.</strong> Údaje ve Vstupních datech zpracovává Poskytovatel jako zpracovatel. Po ukončení smlouvy data odstraní nebo anonymizuje v souladu s DPA.</p>
          </div>

          <div>
            <h2 className="text-xl font-bold mb-3">8. Práva subjektů údajů</h2>
            <p className="mb-3"><strong>8.2.</strong> Subjekt údajů má zejména právo:</p>
            <ul className="list-disc ml-6 space-y-1">
              <li>na přístup k osobním údajům,</li>
              <li>na opravu nepřesných údajů,</li>
              <li>na výmaz osobních údajů,</li>
              <li>na omezení zpracování,</li>
              <li>na přenositelnost údajů,</li>
              <li>vznést námitku proti zpracování,</li>
              <li>podat stížnost u Úřadu pro ochranu osobních údajů.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-bold mb-3">9. Zabezpečení osobních údajů</h2>
            <p>Poskytovatel přijímá přiměřená technická a organizační opatření k ochraně osobních údajů před neoprávněným přístupem, ztrátou nebo zneužitím.</p>
          </div>

          <div>
            <h2 className="text-xl font-bold mb-3">10. Závěrečná ustanovení</h2>
            <p className="mb-2"><strong>10.1.</strong> Tyto ZOOÚ mohou být Poskytovatelem jednostranně aktualizovány, zejména v návaznosti na změny právních předpisů.</p>
            <p className="mb-2"><strong>10.2.</strong> Aktuální znění ZOOÚ je vždy dostupné na webových stránkách Poskytovatele.</p>
            <p><strong>10.3.</strong> Tyto ZOOÚ nabývají účinnosti dnem 1. 1. 2026.</p>
          </div>

          {/* DPA */}
          <div className="mt-12 pt-8 border-t-4 border-teal-500">
            <h1 className="text-3xl font-bold mb-8">DODATEK O ZPRACOVÁNÍ OSOBNÍCH ÚDAJŮ (DPA)</h1>
            
            <div className="space-y-6">
              <div>
                <h2 className="text-xl font-bold mb-3">1. Úvodní ustanovení</h2>
                <p className="mb-2"><strong>1.1.</strong> Tento dodatek upravuje práva a povinnosti při zpracování osobních údajů v souvislosti s poskytováním služby Školobot v souladu s GDPR.</p>
                <p className="mb-2"><strong>1.2.</strong> DPA je nedílnou součástí smluvního vztahu založeného registrací ke Službě a akceptací Obchodních podmínek.</p>
                <p className="mb-3"><strong>1.3.</strong> Smluvními stranami jsou:</p>
                <ul className="list-disc ml-6 mb-3 space-y-1">
                  <li><strong>Poskytovatel (Zpracovatel):</strong> THEBIGDOT s.r.o., IČO: 19062044, Zámostní 1155/27, 710 00 Ostrava</li>
                  <li><strong>Zákazník (Správce):</strong> právnická osoba registrující se ke Službě</li>
                </ul>
                <p className="mb-2"><strong>1.4.</strong> Zákazník prohlašuje, že jedná v rámci podnikatelské nebo institucionální činnosti a není spotřebitelem.</p>
                <p><strong>1.5.</strong> Při rozporu mezi DPA a Podmínkami má ve vztahu k ochraně údajů přednost DPA.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold mb-3">2. Předmět, povaha a doba trvání zpracování</h2>
                <p className="mb-2"><strong>2.1.</strong> Zákazník pověřuje Poskytovatele zpracováním osobních údajů obsažených ve Vstupních datech v rozsahu nezbytném pro poskytování Služby.</p>
                <p className="mb-2"><strong>2.2.</strong> Zpracování probíhá po dobu trvání smluvního vztahu.</p>
                <p className="mb-2"><strong>2.3.</strong> Zahrnuje uložení, zabezpečení, automatizované zpracování, generování Výstupu a umožnění exportu.</p>
                <p className="mb-2"><strong>2.4.</strong> Poskytovatel neurčuje účely zpracování, tyto určuje Zákazník jako správce.</p>
                <p><strong>2.6.</strong> Poskytovatel zpracovává údaje výhradně v rozsahu nezbytném pro Službu a pouze na základě pokynů Zákazníka.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold mb-3">3. Pokyny Zákazníka</h2>
                <p className="mb-2"><strong>3.1.</strong> Zákazník je správcem osobních údajů ve Vstupních datech. Poskytovatel je zpracovatel.</p>
                <p className="mb-2"><strong>3.2.</strong> Poskytovatel zpracovává údaje výlučně na základě doložených pokynů Zákazníka.</p>
                <p><strong>3.4.</strong> Zákazník určuje účely a prostředky zpracování a odpovídá za zákonnost zpracování včetně informačních povinností.</p>
              </div>

              <div className="bg-blue-50 p-6 rounded-xl border-2 border-blue-200">
                <h2 className="text-xl font-bold mb-3">4. Povinnosti Poskytovatele jako zpracovatele</h2>
                <p className="mb-2"><strong>4.1. Důvěrnost:</strong> Osoby oprávněné zpracovávat údaje jsou vázány mlčenlivostí.</p>
                <p className="mb-2"><strong>4.2. Technická opatření:</strong> Poskytovatel přijme přiměřená technická a organizační opatření dle čl. 32 GDPR.</p>
                <p className="mb-2"><strong>4.3. Subdodavatelé:</strong> Zákazník uděluje obecné oprávnění zapojit další zpracovatele (hosting, cloud, podpora). Poskytovatel oznámí změny předem.</p>
                <p className="mb-2"><strong>4.4. Místo zpracování:</strong> Primárně EU/EHP. Předání mimo EU/EHP v souladu s GDPR.</p>
                <p className="mb-2"><strong>4.6. Porušení zabezpečení:</strong> Poskytovatel oznámí porušení bez zbytečného odkladu.</p>
                <p><strong>4.7. Zpracování výlučně pro Službu:</strong> Poskytovatel <strong className="text-blue-700">nevyužívá osobní údaje ani Vstupní data k tréninku modelů umělé inteligence.</strong></p>
              </div>

              <div>
                <h2 className="text-xl font-bold mb-3">5. Povinnosti Zákazníka jako správce</h2>
                <p>Zákazník odpovídá za zákonnost zpracování, stanovení účelů, splnění informačních povinností vůči subjektům údajů a za obsah nahraný do Služby.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold mb-3">6. Audit a prokazování souladu</h2>
                <p>Poskytovatel na žádost zpřístupní informace k prokázání splnění povinností dle čl. 28 GDPR a umožní audit za přiměřených podmínek.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold mb-3">7. Popis zpracování (čl. 28 GDPR)</h2>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Předmět:</strong> osobní údaje ve Vstupních datech</li>
                  <li><strong>Povaha:</strong> ukládání, zabezpečení, automatizovaná analýza, generování Výstupu, export</li>
                  <li><strong>Účel:</strong> automatizované zpracování za účelem vytvoření Výstupu a zajištění provozu Služby</li>
                  <li><strong>Kategorie subjektů:</strong> Uživatelé, osoby ve Vstupních datech (zaměstnanci, děti, zákonní zástupci)</li>
                  <li><strong>Kategorie údajů:</strong> identifikační, kontaktní, obsahové, technické</li>
                </ul>
              </div>

              <div className="bg-green-50 p-6 rounded-xl border-2 border-green-200">
                <h2 className="text-xl font-bold mb-3">8. Výmaz a anonymizace po ukončení zpracování</h2>
                <p className="mb-2"><strong>8.1.</strong> Zákazník má možnost exportovat data průběžně po dobu trvání smlouvy.</p>
                <p className="mb-2"><strong>8.2.</strong> Po ukončení poskytování Služby zaniká Zákazníkovi právo na přístup k datům.</p>
                <p className="mb-2"><strong>8.3.</strong> Poskytovatel osobní údaje <strong className="text-green-700">vymaže nebo anonymizuje nejpozději do 60 dnů</strong> od ukončení Služby, není-li další uchování vyžadováno právními předpisy.</p>
                <p><strong>8.4.</strong> Omezené kopie mohou přetrvávat v záložních systémech po dobu standardního cyklu obnovy. Během této doby budou chráněny a nebudou aktivně zpracovávány.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold mb-3">9. Závěrečná ustanovení</h2>
                <p className="mb-2"><strong>9.1.</strong> DPA nabývá účinnosti v souladu s bodem 1.2.</p>
                <p className="mb-2"><strong>9.2.</strong> Právní vztahy se řídí Podmínkami. Rozhodné právo: Česká republika.</p>
                <p><strong>9.3.</strong> DPA může být měněno způsobem stanoveným v Podmínkách nebo písemnou dohodou, vždy v souladu s GDPR.</p>
              </div>
            </div>
          </div>

          <div className="bg-teal-50 border-2 border-teal-200 rounded-xl p-6 mt-10">
            <p className="text-sm">
              <strong>Kontakt pro GDPR:</strong> Pro uplatnění svých práv nás kontaktujte přes <a href="/kontakt" className="text-teal-700 hover:underline font-semibold">kontaktní formulář</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
